import React from "react";
import { Spinner } from "react-bootstrap";

export const FullPageOverlay = () => {
  return (
    <div className="fullLoadingContainer fixed hasLightBg">
      <div className="loadingContainerOverlay"></div>
      <Spinner animation="border" role="status" className="loadingSpinner">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};
